export default "__VITE_ASSET__8128824b__"